export default __webpack_public_path__ + "static/media/Icons-43.ca1d8b28.png";